
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/creator/interview-kabuzaru",
      function () {
        return require("private-next-pages/about/creator/interview-kabuzaru.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/creator/interview-kabuzaru"])
      });
    }
  